const arrayMoveMutate = function(array, from, to) {
  const startIndex = to < 0 ? array.length + to : to;
  const item = array.splice(from, 1)[0];
  array.splice(startIndex, 0, item);
};

const arrayMove = function(array, from, to) {
  array = array.slice();
  arrayMoveMutate(array, from, to);
  return array;
};

export default arrayMove;
